import {
  Box,
  Button,
  Divider,
  Popover,
  ListItem,
  Typography,
  ListItemButton,
  Tooltip,
} from '@mui/material';
import { t } from 'i18next';
import { Settings, Logout, DoDisturbOn } from '@mui/icons-material';

import { ProfileAvatar } from 'components/ProfileAvatar';
import { ClipboardButton } from 'components/ClipboardButton';
import { theme } from '@store';

import { useProfileMenu } from '../hooks';
import { ConfirmationModal } from 'components/ConfirmationModal';

export const ProfileMenu = () => {
  const {
    user,
    handleOpen,
    handleClose,
    anchorEl,
    navigate,
    profile,
    handleChangeStatusToAway,
    handleSignoutConfirmationOpen,
    handleSignoutConfirmationClose,
    isSignoutConfirmationOpen,
    confirmSignout,
    tooltipText,
  } = useProfileMenu();

  return (
    <>
      <Tooltip title={tooltipText}>
        <Button onClick={handleOpen}>
          <ProfileAvatar
            encoded_image={profile.image?.thumbnail_xsmall}
            firstName={profile.first_name}
            lastName={profile.last_name}
            status={profile.activity_status}
          />
        </Button>
      </Tooltip>
      <Popover
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        sx={{
          zIndex: 5,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'flex-start',
            flexDirection: 'column',
            width: 261,
          }}
        >
          <Box sx={{ padding: '16px 16px' }}>
            <Typography
              variant='body1'
              sx={{
                width: '220px',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
              }}
            >
              {`${user?.first_name} ${user?.last_name} ${user?.suffix ? user.suffix : ''}`}
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography
                variant='body2'
                sx={{
                  maxWidth: '195px',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  color: 'rgba(0, 0, 0, 0.60)',
                  fontWeight: '400',
                  fontSize: '12',
                }}
              >
                {user?.email}
              </Typography>
              {user?.email && (
                <ClipboardButton textToCopy={user.email} size={16} />
              )}
            </Box>
          </Box>
          <Box
            sx={{
              padding: '4px 16px',
              backgroundColor: theme.palette.success.main,
              borderRadius: 4,
              color: theme.palette.common.white,
              ml: 2,
              mb: 1,
            }}
          >
            {user?.roles[0]}
          </Box>
          <ListItem disablePadding>
            <ListItemButton
              sx={{
                padding: '8px 16px',
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
              }}
              onClick={handleChangeStatusToAway}
            >
              <DoDisturbOn sx={{ height: '1.5rem' }} color='primary' />
              <Typography variant='body2'>
                {t('header.profileMenu.setAway')}
              </Typography>
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              onClick={() => {
                handleClose();
                navigate('/profile');
              }}
              sx={{
                padding: '8px 16px',
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
              }}
            >
              <Settings sx={{ height: '1.5rem' }} color='primary' />
              <Typography variant='body2'>
                {t('header.profileMenu.manageAccount')}
              </Typography>
            </ListItemButton>
          </ListItem>
          <Divider
            sx={{
              margin: '7px 0',
              width: '100%',
              backgroundColor: 'rgba(0, 0, 0, 0.12)',
            }}
          />
          <ListItem disablePadding>
            <ListItemButton
              onClick={handleSignoutConfirmationOpen}
              sx={{
                padding: '8px 16px',
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                mb: 1,
              }}
            >
              <Logout sx={{ height: '1.5rem' }} color={'error'} />
              <Typography
                variant='body2'
                sx={{ color: 'error.main', fontSize: '1rem' }}
              >
                {t('header.profileMenu.signOut')}
              </Typography>
            </ListItemButton>
          </ListItem>
        </Box>
      </Popover>
      {/* <Modal open={isAwayModalOpen} onClose={handleAwayModalClose}>
        <Box
          sx={{
            height: '100vh',
            display: 'grid',
            placeItems: 'center' }}
        >
          <Box
            sx={{
              p: 3,
              backgroundColor: 'white',
              display: 'flex',
              flexDirection: 'column',
              gap: 3,
              width: 600 }}
          >
            <Typography variant='h6' component='h2'>
              {t('common.setAsActiveModal.title')}
            </Typography>
            <Typography variant='body1'>
              {t('common.setAsActiveModal.text')}
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                onClick={handleChangeStatusToActive}
                variant='contained'
                color='secondary'
                sx={{
                  fontSize: '0,875rem',
                  fontWeight: 'medium',
                  lineHeight: '24px',
                  color: 'white' }}
              >
                {t('common.setAsActiveModal.confirm')}
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal> */}

      <ConfirmationModal
        title={t('profile.detailsCard.signoutConfirmationTitle')}
        message={t('profile.detailsCard.signoutConfirmationDescription')}
        onConfirm={confirmSignout}
        onClose={handleSignoutConfirmationClose}
        isOpen={isSignoutConfirmationOpen}
        confirmText={'SIGN OUT'}
      />
    </>
  );
};
